export const STORAGE_KEY_IS_FIRST_ACCESS = 'isFirstAccess';

export function setFirstAccess(): boolean {
	if (typeof window === 'undefined') return true;
	const raw = localStorage.getItem(STORAGE_KEY_IS_FIRST_ACCESS);
	if (raw === null) {
		localStorage.setItem(STORAGE_KEY_IS_FIRST_ACCESS, 'true');
		return true;
	}
	try {
		const current = JSON.parse(raw) === true;
		if (current) {
			localStorage.setItem(STORAGE_KEY_IS_FIRST_ACCESS, 'false');
			return false;
		}
		return false;
	} catch {
		localStorage.setItem(STORAGE_KEY_IS_FIRST_ACCESS, 'true');
		return true;
	}
}

export function isFirstAccess(): boolean {
	if (typeof window === 'undefined') return true;
	const raw = localStorage.getItem(STORAGE_KEY_IS_FIRST_ACCESS);
	if (raw === null) return true;
	try {
		return JSON.parse(raw) === true;
	} catch {
		return true;
	}
}
